import {useTranslation} from "react-i18next";
import {isNull} from "lodash";

const capitalizeFirst = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1);

export const getCertificationInfo = (item: BrokerOutput, t: (key: string) => string) => {

  if (item.has_certificate) {
    return t('dictionaries__text__certification__thereIsAValidCertificate')
  }

  if (isNull(item.has_certificate)){
    return capitalizeFirst(t('dictionaries__text__certification__certificationIsNotRequired'));
  }

  const company = item.company?.name
  const cost = item.cost_total != null ? `${item.cost_total} USD` : '—'

  return company ? `${company} — ${cost}` : cost
}

export const getCertificateInfo = (summaryCertification?: BrokerOutput[]) => {

  const { t } = useTranslation();

  if (!summaryCertification) {
    return [];
  }

  return [
    summaryCertification.map(item => (
      {
        label: `${item.code} (${item.country_code})`,
        value: getCertificationInfo(item, t),
      }
    ))
  ]
}
